import { userSchema } from "../userBase.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/auth/signInWithGoogleToken.ts
const signInWithGoogleTokenRoute = oc.route({
	method: "POST",
	path: "/sign-in/token/google",
	summary: "Sign in with a Google identity token. Creates an account if none is linked."
}).input(z.object({ token: z.string().min(1) })).output(z.object({
	isNew: z.boolean(),
	user: userSchema
}));
//#endregion
export { signInWithGoogleTokenRoute };
